import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomLoadingPriceStateType {
    readonly isLoadingPrice: boolean;
}

export type CustomLoadingPriceState = Readonly<CustomLoadingPriceStateType>;

export const initialCustomLoadingPriceState: CustomLoadingPriceState = {
    isLoadingPrice: false,
};

export const customLoadingPriceReducer = createTypedReducer(initialCustomLoadingPriceState, {
    "Custom/LoadingPrice/BeginLoadingPrice": (draft: Draft<CustomLoadingPriceState>) => ({
        ...draft,
        isLoadingPrice: true,
    }),
    "Custom/LoadingPrice/CompleteLoadingPrice": (draft: Draft<CustomLoadingPriceState>) => ({
        ...draft,
        isLoadingPrice: false,
    }),
});
